<a
     class="card-block copo-clickable"
     mat-ripple
     [routerLink]="['/order-tracking/shipment/card', shipment.supplierShipmentNumber]">
	<div class="order-tracking-list-card-header">
		<span class="order-tracking-list-card-header-title">{{ shipment.dispatchAdviceNumber }}</span>
		<span class="order-tracking-list-card-header-ton">{{  shipment.qtyShipmentBrut | copoNumber:'weight':'t' }}</span>
	</div>
	<div class="order-tracking-list-card-informations-block">
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>shipment.transport-reference</span>
			<span class="order-card-value">{{ shipment.transportReferenceConcat }}</span>
		</div>
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>shipment.filter.transport-mode</span>
			<span class="order-card-value">{{ shipment.transportModeDescription }}</span>
		</div>
	</div>
	<div class="order-tracking-list-card-informations-block">
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>shipment.filter.ship-to</span>
			<span class="order-card-value">{{ shipment.shipToDescription }}</span>
		</div>
	</div>
</a>
